import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Hero from "../components/sections/Hero";
import WhoWeAre from "../components/sections/WhoWeAre";
import Services from "../components/sections/Services";
import WhyChooseUs from "../components/sections/WhyChooseUs";
import Testimonials from "../components/sections/Testimonials";
import Gallery from "../components/sections/Memories";
import Enquiry from "../components/sections/Enquiry";
import CollaborationHighlight from "../components/sections/CollaborationHighlight";
// import SpecialOffer from "../components/sections/SpecialOffer";


export default function Home() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const id = location.state.scrollTo;

      setTimeout(() => {
        const section = document.getElementById(id);

        if (section) {
          section.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }

        navigate(location.pathname, { replace: true });
      }, 300);
    }
  }, [location, navigate]);

  return (
    <>
      <Hero />
      {/* <SpecialOffer /> */}
      <WhoWeAre />

      <section id="services">
        <Services />
      </section>

      <WhyChooseUs />
      <CollaborationHighlight />
      <Testimonials />
      <Gallery />

      <section id="enquiry">
        <Enquiry />
      </section>
    </>
  );
}
